module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/419.79e2b264.png";